import { DetailTable } from "../../components/DetailTable";
import { useDealStructureData } from "./useDealStructureData";
import { JumpToSection } from "../../components/JumpToSection";
import { ExpandableMarkdown } from "../../components/ExpandableMarkdown";
import { LabelLLM } from "../../components/LabelLLM";
import { useAtomValue } from "jotai";
import { showDataSourcesAtom } from "../../state";
import { SourceTag } from "../../components/SourceTag";

export function DealStructure({ opportunityId }: { opportunityId?: string }) {
    const {
        productData,
        economicsData,
        termsConditionsData,
        covenants,
        isLoading,
    } = useDealStructureData({ opportunityId });
    const showDataSources = useAtomValue(showDataSourcesAtom);

    return (
        <>
            <div className="space-y-12">
                <DetailTable
                    title="Product"
                    data={productData}
                    isLoading={isLoading}
                />
                <DetailTable
                    title="Economics"
                    data={economicsData}
                    isLoading={isLoading}
                />
                <DetailTable
                    title="Terms & Conditions"
                    data={termsConditionsData}
                    isLoading={isLoading}
                />
            </div>
            <div className="space-y-6">
                <div className="mt-6">
                    <h3 className="heading-m mb-3">Covenants</h3>
                    <div>
                        <div className="mb-2">
                            <ExpandableMarkdown
                                text={covenants.value.toString()}
                                maxLength={1800}
                            />
                        </div>
                        {showDataSources && covenants.source && (
                            <SourceTag
                                source={covenants.source}
                                fieldName={covenants.fieldName}
                            />
                        )}
                        <LabelLLM />
                    </div>
                </div>
            </div>
            <JumpToSection
                targetSection="capital-and-deal-structure"
                label="Jump to Capital & Deal Structure"
            />
        </>
    );
}
